var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebFormIntCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "webform-int-shadow",
    x: 0,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#webform-int-shadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 32,
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(22 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 36,
    rx: 4,
    fill: "#EFF6FF",
    stroke: "#3663FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 6,
    width: 24,
    height: 3,
    rx: 1.5,
    fill: "#3663FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13,
    width: 24,
    height: 2,
    rx: 1,
    fill: "#94A3B8",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 18,
    width: 18,
    height: 2,
    rx: 1,
    fill: "#94A3B8",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 23,
    width: 24,
    height: 2,
    rx: 1,
    fill: "#94A3B8",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 29,
    width: 16,
    height: 4,
    rx: 2,
    fill: "#3663FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebFormIntCircleIcon);
export default __webpack_public_path__ + "static/media/web-form-int-circle-icon.73825b36c0494ebbd6e10fa00f040188.svg";
export { ForwardRef as ReactComponent };